import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ExplorerToolbarComponent} from '@catmodules/widgets/explorer/components/explorer-toolbar/explorer-toolbar.component';
import {ExplorerComponent} from '@catmodules/widgets/explorer/components/explorer/explorer.component';
import {ItemStateComponent} from '@catmodules/widgets/explorer/components/item-state/item-state.component';
import {TreeNodeTemplateLoaderComponent} from '@catmodules/widgets/explorer/components/tree-node-template-loader/tree-node-template-loader.component';
import {TreeNodeComponent} from '@catmodules/widgets/explorer/components/tree-node/tree-node.component';
import {TreeComponent} from '@catmodules/widgets/explorer/components/tree/tree.component';

const publicComponents = [
  ExplorerComponent,
];

@NgModule({
  imports: [CommonModule],
  exports: [
    ...publicComponents,
  ],
  declarations: [
    ...publicComponents,
    ItemStateComponent,
    ExplorerToolbarComponent,
    ExplorerComponent,
    TreeComponent,
    TreeNodeTemplateLoaderComponent,
    TreeNodeComponent,
  ],
  entryComponents: [
  ],
  providers: [],
})
export class ExplorerModule {

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/widgets/explorer/explorer.module.ts